import Echo, { type Broadcaster } from 'laravel-echo'

import { useCustomerStore } from '@stores/me/customer'

import { useListenEventAssessment } from '@ws/listen-event-assessment.hook'
import { useListenEventBooking } from '@ws/listen-event-booking.hook'
import { useListenEventCustomer } from '@ws/listen-event-customer.hook'
import { useListenEventRetryPayment } from '@ws/listen-event-subscription-retry.hook'
import { useStopListener } from '@ws/stop-listener.hook'
import { useListenEventProgressReport } from '@ws/listen-event-progress-report.hook'
import { useListenEventDiscipline } from '@ws/listen-event-discipline.hook'

export const useListenCustomerChannel = ($echo: Echo<keyof Broadcaster>): void => {
  const customerStore = useCustomerStore()

  if (customerStore.customer) {
    const name = `cs.customer.${customerStore.customer.id}`
    const channel = $echo.private(name)

    useListenEventCustomer(channel)
    useListenEventDiscipline(channel)
    useListenEventBooking(channel)
    useListenEventAssessment(channel)
    useListenEventRetryPayment(channel)
    useListenEventProgressReport(channel)

    useStopListener($echo, name, channel)
  }
}
